import { createContext } from 'react'

const GlobalContext = createContext({
    currentTime: 0,
    setCurrentTime: (newValue: number) => {},
    currentDistance: "0",
    setCurrentDistance: (newValue: string) => {},
    scrollIndex: 0,
    setScrollIndex: (newValue: number) => {},
    colorMode: 'light',
    lang: 'de',
    locale: {} as Locale,
    headerHeight: 0,
    
})

export default GlobalContext